import { useContext } from "react"
import { LoaderContext } from "../utils/loaderContext"
import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

export const CustomLoader = ({children}: any) => {
    const loaderContext = useContext(LoaderContext)

    return <>{<Spin tip={loaderContext.message}  spinning={loaderContext.loader} fullscreen={true}>{children}</Spin>}</>
}